<template>
<div>
  <!-- 顶部搜索区域 -->
  <div class="search-container">
    <el-form :inline="true" :model="searchForm" class="demo-form-inline">
      <el-form-item label="发票号码">
        <el-input v-model="searchForm.invoiceNo" placeholder="请输入发票号码"></el-input>
      </el-form-item>
      <el-form-item label="开票时间">
        <el-date-picker
          v-model="searchForm.date" type="month" value-format="yyyyMM"
          placeholder="选择月份"
          @change="handleSearch">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="购方税号">
        <el-input v-model="searchForm.buyerTaxCode"></el-input>
      </el-form-item>
      <el-form-item label="购方单位名称/发票抬头">
        <el-input v-model="searchForm.buyerName"></el-input>
      </el-form-item>
      <el-form-item label="发票类型">
        <el-checkbox-group v-model="searchForm.invoice_type">
          <el-checkbox label="数电专票" value="'81'">数电专票</el-checkbox>
          <el-checkbox label="数电普票" value="82">数电普票</el-checkbox>
          <el-checkbox label="纸质专票（数电）" value="85">纸质专票(数电)</el-checkbox>
          <el-checkbox label="纸质普票（数电）" value="86">纸质普票(数电)</el-checkbox>
          <el-checkbox label="增值税专票" value="004">增值税专票</el-checkbox>
          <el-checkbox label="增值税普通发票" value="005">增值税普通发票</el-checkbox>
          <el-checkbox label="普通电子发票" value="026">普通电子发票</el-checkbox>
          <el-checkbox label="电子专用发票" value="028">电子专用发票</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleSearch">搜索</el-button>
      </el-form-item>
    </el-form>
  </div>

  <!-- 表格区域 -->
  <div class="table-container">
    <el-table
      :data="tableData"
      border v-loading="loading"
      style="width: 100%">
      <el-table-column
        prop="invoiceNo"
        label="发票号码">
      </el-table-column>
      <el-table-column prop="invoiceCode" label="发票代码"></el-table-column>
      <el-table-column
        prop="invoiceDate"
        label="开票时间">
      </el-table-column>
      <el-table-column
        prop="taxAmount"
        label="发票税额">
      </el-table-column>
      <el-table-column label="发票类型">
        <template slot-scope="scope">
          <span v-if="scope.row.invoiceKindCode === '81'">数电专票</span>
          <span v-else-if="scope.row.invoiceKindCode === '82'">数电普票</span>
          <span v-else-if="scope.row.invoiceKindCode === '85'">纸质专票(数电)</span>
          <span v-else-if="scope.row.invoiceKindCode === '86'">纸质普票(数电)</span>
          <span v-else-if="scope.row.invoiceKindCode === '004'">增值税专票</span>
          <span v-else-if="scope.row.invoiceKindCode === '005'">增值税普通发票</span>
          <span v-else-if="scope.row.invoiceKindCode === '026'">普通电子发票</span>
          <span v-else-if="scope.row.invoiceKindCode === '028'">电子专用发票</span>
        </template>
      </el-table-column>
      <el-table-column prop="totalAmount" label="合计"></el-table-column>
      <el-table-column label="状态">
        <template slot-scope="scope">
          <span v-if="scope.row.invoiceStatus === '01'">正常</span>
          <span v-if="scope.row.invoiceStatus === '02'">作废</span>
          <span v-if="scope.row.invoiceStatus === '03'">全额红冲</span>
          <span v-if="scope.row.invoiceStatus === '04'">部分红冲</span>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button v-if="['81','82','85','86'].includes(scope.row.invoiceKindCode)" size="mini" @click="handleView(scope.row)">查看</el-button>
          <el-button v-if="scope.row.is_erp_exist === 0 && scope.row.invoiceStatus === '01' && scope.row.taxAmount > 0"
                     size="mini" type="danger" @click="handleReverse(scope.row)">红冲</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>

  <invoice-detail :invoiceId="detailChange" :visible="invoiceDetailVisible" :search_type="'tax_invoice'"
                  :search_params="detailParams"
                   @close="invoiceDetailVisible = false"></invoice-detail>
</div>
</template>

<script>
import InvoiceDetail from "./invoiceDetail.vue";

export default {
  components: {InvoiceDetail},
  data() {
    return {
      searchForm: {
        invoiceNo: '',
        date: '',
        invoice_type : ['数电专票' , '数电普票'],
        buyerTaxCode : '',
        buyerName : '',
      },
      tableData: [],
      loading : false,

      invoiceDetailVisible : false,
      detailChange : 0,
      detailParams : {},
    }
  },
  props: {
    pindex_id: {
      type: [String, Number],
      required: true
    },
    disc_id : {
      type : [String , Number] ,
      default : 0 ,
    }
  },
  methods: {
    handleSearch() {
      if(this.searchForm.date == ''){
        this.$message.error("请选择日期");
        return;
      }
      let that = this;
      this.$myhttp.post(
        "admin/taxInvoiceList",
        {
          pid : this.pindex_id ,
          // beginDate : this.searchForm.date,
          // endDate : this.searchForm.date ,
          month : this.searchForm.date,
          invoiceNo : this.searchForm.invoiceNo,
          invoice_type : this.searchForm.invoice_type,
          buyerTaxCode : this.searchForm.buyerTaxCode,
          buyerName : this.searchForm.buyerName,
          disc_id : this.disc_id ,
        },
        {"Content-Type": "application/json",}
      ).then((backdata) => {
        if (backdata.data.code == 200) {
          that.tableData = backdata.data.data;
        } else {
          this.$message.error(backdata.data.msg);
        }
      })
        .catch((err) => {
          this.$message.error(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleView(row) {
      this.detailChange ++ ;
      this.invoiceDetailVisible = true;
      this.detailParams = {
        invoice_no : row.invoiceNo ,
        invoice_type : row.invoiceKindCode ,
        invoice_date : row.invoiceDate ,
        project_id : this.pindex_id,
      };
    },
    handleReverse(row) {
      this.$confirm('确认要红冲发票 ？').then(() => {
        // 红冲逻辑 invoiceCancel
        let that = this;
        this.$myhttp.post(
          "admin/taxInvoiceCancel",
          {
            disc_id : row.disc_id ,
            invoice_date : row.invoiceDate ,
            invoice_no : row.invoiceNo,
            invoice_type : row.invoiceKindCode ,
            special_flag : row.hasOwnProperty('specialFlag') ? row.specialFlag : '' ,
            invoice_code : row.hasOwnProperty('invoiceCode') ? row.invoiceCode : '' ,
          },
          {"Content-Type": "application/json",}
        ).then((backdata) => {
          if (backdata.data.code == 200) {
            this.$message.success(backdata.data.msg);
          } else {
            this.$message.error(backdata.data.msg);
          }
        })
      });
    },
    invoiceDetailVisible(){
      this.invoiceDetailVisible = false;
    },
  }
}
</script>

<style scoped lang="scss">
.search-container {
  padding: 20px;
  background: #fff;
  margin-bottom: 20px;
}
.table-container {
  background: #fff;
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Finance/TaxInvoiceList.vue